import React from 'react';

import searchIcon from './search-icon.svg';
import closeIcon from './close-icon.svg';

import './hero.css';

const Hero = (props) => {
    return (
        <div className="apps-hero">
            <div className="hero-container">
                <img className="hero-image" src="https://s3-eu-west-1.amazonaws.com/circleloop-assets/images/integrations/integrations-intro.png"/>
                <div className="hero-titles">
                    <h1>Integrations Control Centre</h1>
                    <p>Install, configure and manage our growing list of powerful integrations.</p>
                    <div className="apps-search-container">
                        <input type="text" onChange={props.onSearch} value={props.search} placeholder="Search for an integration" className="apps-search-input"/>
                        <img src={searchIcon} alt="Search" className="search-icon"/>
                        {props.search ? <img onClick={props.onClearSearch} src={closeIcon} alt="Clear" className="clear-icon"/> : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Hero;


// WEBPACK FOOTER //
// ./src/components/Hero/index.js